// The Samples Gallery's categories.
//
// The taxonomy is the platform's; the catalog (see backend/app/services/
// samples_service.py) only NAMES one per application through its `category`
// field — by `key`, or by the label spelled out, either matches. "Others" is
// a category in its own right (`other`), and is also where an entry naming no
// category here lands, so a catalog edit can never hide an application.

export interface SampleCategory {
  key: string
  label: string
  /** Material icon name. */
  icon: string
  description: string
}

export const SAMPLE_CATEGORIES: SampleCategory[] = [
  {
    key: 'vision-extension',
    label: 'Vision Extension',
    icon: 'extension',
    description: 'Screens, lookups and logic that extend an existing Vision application.',
  },
  {
    key: 'analytics',
    label: 'Analytics / Dashboards',
    icon: 'insights',
    description: 'Data models, visuals and dashboards over business data.',
  },
  {
    key: 'process-automation',
    label: 'Business Process Automation',
    icon: 'account_tree',
    description: 'Requests, approvals and status flows that replace email and spreadsheets.',
  },
  {
    key: 'data-websites',
    label: 'Data Driven Websites',
    icon: 'web',
    description: 'Public sites whose pages are built from the application’s own records.',
  },
  {
    key: 'event-websites',
    label: 'Event Websites',
    icon: 'event',
    description: 'Event sites with schedules, registrations and attendee management.',
  },
  {
    key: 'ecommerce',
    label: 'E-commerce',
    icon: 'storefront',
    description: 'Storefronts with catalogues, carts, checkout and order handling.',
  },
  {
    key: 'intranet',
    label: 'Intranet Portals',
    icon: 'corporate_fare',
    description: 'Internal portals for documents, knowledge and employee self-service.',
  },
  {
    key: 'integration',
    label: 'Integration / Middleware',
    icon: 'hub',
    description: 'Connect applications and move data between systems.',
  },
]

export const OTHER_CATEGORY: SampleCategory = {
  key: 'other',
  label: 'Others',
  icon: 'apps',
  description: 'Samples that don’t fit the categories above.',
}

const normalise = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, '')

/** The category a catalog `category` value names, or OTHER_CATEGORY. */
export function categoryOf(value?: string): SampleCategory {
  if (!value) return OTHER_CATEGORY
  const v = normalise(value)
  return SAMPLE_CATEGORIES.find(
    (c) => normalise(c.key) === v || normalise(c.label) === v,
  ) ?? OTHER_CATEGORY
}
